// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".banner{\n    padding:20px;\n}\n\n.banner__close-icon{\n    position:absolute;\n\n    top:0.4rem;\n    right:1rem;\n\n    color:white;\n    opacity: 1;\n}\n.banner__close-icon:hover,\n.banner__close-icon:focus{\n    color:white;\n    opacity:0.6;\n}\n", ""]);
// Exports
module.exports = exports;
